import React from "react";
import { withAuth } from "shared/context/auth";
import { buildQAHook } from "shared/utils";
import config from "../../config";
import MenuLink from "../MenuLink";

const UserMenu = ({ auth }) => {
  if (auth.isUserSignedIn) {
    const { user } = auth;
    const userMenu = config.getUserMobileMenu(user);

    return (
      <ul>
        {userMenu.items.map((item) => (
          <li key={item.url}>
            <MenuLink
              data-qa={buildQAHook(item.title, "usermenu", "link")}
              href={item.url}
            >
              {item.title}
            </MenuLink>
          </li>
        ))}
      </ul>
    );
  }

  const signInItem = config.getSignInItem();

  return (
    <ul>
      <li>
        <MenuLink href={signInItem.url}>{signInItem.title}</MenuLink>
      </li>
    </ul>
  );
};

export default withAuth(UserMenu);
